export default __webpack_public_path__ + "static/media/mnav-r.099a1ae3.svg";